import { AnyAction } from 'redux';

const rootReducer = (initialState: any = {}) => (
  state: any = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        ...action.value,
      };
    case 'RESET':
      return {};
    default:
      return state;
  }
};

export default rootReducer;
